import React from "react";
import StrategyToolbar from "components/toolbars/StrategyToolbar";
import Page from "design/pages/Page";
import PageContainer from "../../design/layouts/PageContainer";
import FinancialAnalytics from "./FinancialAnalytics";

const Analytics = () => {
  return (
    <Page isLoading={false} Toolbar={StrategyToolbar}>
      <PageContainer width="100%">
        <FinancialAnalytics />
      </PageContainer>
    </Page>
  );
};

export default Analytics;
